<template>
  <div id="app" :class="{'horizontal' : horizontal && this.$store.getters.auth }">
    <div id="snackbar" :class="{'show' : this.$store.getters.notificationToShow }" v-html="this.$store.getters.notificationToShow.text">
    </div>



    <div class="loading" v-if="showLoading">
      <div>Bitte warten.</div>
    </div>
    <header v-if="this.$store.getters.auth">
      <div class="branding" v-on:click="horizontal=!horizontal">{{ this.$store.getters.user.name }}</div>
      <nav>
        <ul v-if="!this.$store.getters.isAdmin">
          <li :class="{ 'active-menu': this.$route.name == 'dashboard' }" v-on:click="ChangeRoute('dashboard')">{{currentLang["STR_DASHBOARD"] }}</li>
          <li :class="{ 'active-menu': this.$route.name == 'documents' }" v-on:click="ChangeRoute('documents')">{{currentLang["STR_DOCUMENTS"] }}</li>


          <li v-if="horizontal" :class="{ 'active-menu': this.$route.meta.group == 'cfg' }" v-on:click="ChangeRoute('Settings')">
            API
          </li>

          <li :class="{ 'active-menu': this.$route.meta.group == 'pcr' }" v-on:click="ChangeRoute('devices')">{{currentLang["STR_PCR_DEVICES"] }}</li>
          <li v-if="this.$store.getters.ScreeningPortalEnabled" :class="{ 'active-menu': this.$route.meta.group == 'dfu' }" v-on:click="ChangeRoute('ScreeningPortal')">{{currentLang["STR_SCREENING_PORTAL"]}}
            <span class="bubble" v-if="this.$store.getters.SPQueued.filter(e => e.transfered !== 1).length > 0">{{ this.$store.getters.SPQueued.filter(e => e.transfered !== 1).length }}</span>
          </li>
          <li :class="{ 'active-menu': this.$route.meta.group == 'stat' }" v-on:click="ChangeRoute('stats')">{{currentLang["STR_STATS"]}}</li>
          <li :class="{ 'active-menu': this.$route.meta.group == 'tests' }" v-on:click="ChangeRoute('ShowTests')">{{currentLang["STR_TESTS"]}}</li>
        </ul>
        <ul v-if="this.$store.getters.isAdmin">
          <li>
            <div class="searchbar">
              <div class="search"><input v-model="search" placeHolder="Kundennummer, Probennummer, Seriennummer, ..." class="adminsearcher" /></div>
              <div class="icon"><i class="fas fa-search"></i></div>
            </div> 
          </li>
          <li>
            <select style="width: 500px" v-model="changeuser">
              <option selected></option>
              <option v-for="i in this.$store.getters.getClients" :value="i" v-bind:key="i.id">
                {{ i.apoCustomerId }} - {{ i.name }}
              </option>
            </select>
          </li>
        </ul>
      </nav>

      <div class="refresh" v-on:click="Reload()" title="Daten aktualisieren" v-if="!this.$store.getters.AccessTokenExpired">
        <i class="fas fa-redo" v-if="!reloaded"></i>
        <i class="fas fa-check-circle" :class="{ 'animated flash' : reloaded }" v-if="reloaded" style="color: lightgreen"></i>
      </div>
      <div class="logout">
        <ul>
          {{ this.$store.getters.person }}
          <div class="submenu">
          <ul>
            <li v-on:click="Logout()">
              {{ currentLang["STR_LOGOUT"]}}
            </li>
          </ul>
          </div>
        </ul>
      </div>
    </header>
    <section v-on:click="RenewTokens" class="relogin" v-if="this.$store.getters.auth && this.$store.getters.AccessTokenExpired">
      Ihre Sitzung l&auml;uft demn&auml;chst ab, bitte klicken Sie <b>hier</b> um die Sitzung zu verl&auml;ngern.
    </section>
    <section class="notification" v-if="this.$store.getters.contractSigned == 0">
      Bitte best&auml;tigen Sie uns <b>hier</b>, dass Sie eine Unterweisung bez&uuml;glich der Verwendung Ihrer POC Ger&auml;te, erhalten haben.
    </section>

<!--
    <div class="specialUser" v-if="specialUser" v-on:click="KillSpecialUser">
      Hallo! Sch&ouml;n, dass du da bist <strong>&#9825;</strong>
    </div>
-->

    <section class="content" :class="{ 'no-padding' : !this.$store.getters.auth || this.$store.getters.AccessTokenExpired }">
      <router-view :translation="translation" @LoadingScreen="LoadingScreen" :transl="currentLang" :curves="curves" @notification="ShowNotification" @SetLang="SetLang" :suggestions="suggestions"/>
    </section>
  </div>
</template>


<style>
.horizontal {
  display: flex !important;
  flex-direction: row !important;
}
.horizontal header {
  width: 300px !important;
  display: flex !important;
  flex-direction: column !important;
  position: fixed;
  height: 100%;
}
.horizontal .content {
  margin-left: 320px !important;
}
.horizontal nav {
  width: 100%;
  padding: 0px !important;
  height: calc(100% - 100px);
}
.horizontal .refresh {
  display: none;
}

.horizontal nav ul {
  display: flex !important;
  flex-direction: column !important;
  width: 100% !important;
  margin: 0px !important;
}
.horizontal nav ul li {
  text-align: left;
  margin: 0px !important;
}

.horizontal .branding {
  font-weight: bold;
  width: 100%;
  text-transform: uppercase;
  overflow: hidden !important;
}
.bubble {
  background-color: #ff4800;
  padding-left: 5px;
  padding-right: 5px;
  text-align: center;
  border-radius: 5px;
  margin-left: 10px;
  font-weight: normal;
}
.notification {
  background-color: #003cff;
  color: #fff;
  padding: 10px;
}
.relogin {
  background-color: #964542;
  padding: 10px;
  color: #fff;
  cursor: pointer;
}
.qrcodeholder {
  justify-content: center;
  align-items: center;
  background-color: black !important;
}
.failqr {
  background-color: red !important;
}
.spcsuccess {
  background-color: lightgreen !important;
}
.sperror {
  background-color: red !important;
}
.successqr {
  background-color: lightgreen !important;
}
.search-result {
  display: flex;
  width: 100%;
  flex-direction: column;
  margin-bottom: 15px;
}
.search-result .links {
  width: 250px;
  padding: 15px;
  cursor: pointer;
}
.search-result .links a {
  color: #fff;
  text-decoration: none;
}
.search-result-header {
  display: flex;
  width: 100%;
  flex-direction: row;
  background-color: gray;
}
.search-result .aponame {
  width: calc(100% - 250px - 250px);
  padding: 15px;
  color: #fff;
}

.search-result .kdnr {
  width: calc(100% - 250px - 250px);
  padding: 15px;
  color: #fff;
}
.info {
  background-color: #98a589;
  color: #fff;
}
.submenu {
  display: none;
  position: absolute;
  background-color: rgb(50, 51, 52);
  text-align: left;
  width: 240px;
  top: 48px;
  right: 0px;
  font-weight: normal;
  cursor: pointer;
}
.submenu > ul {
  padding-left: 15px !important;
  color: #fff;
}
.submenu ul a {
  color: #fff;
  text-decoration: none;
}
@media only screen and (max-width: 800px) {
  .horizontal .content {
    margin-left: 0px !important;
  }
  .horizontal nav  {
    width: 100% !important;
    display: flex;
    flex-direction: row !important;
  }
  .horizontal nav ul {
    color:red;
    display: flex;
    flex-direction: row !important;
  }
  .horizontal header {
    height: 45px !important;
    width: 100%;
  }
  .chart, .chart2 {
    width: 100%;
    min-width: unset !important;
  }
  .charts {
    flex-direction: column !important;
    width: 100% !important;
  }
  .hideonmobile {
    display: none;
  }
  .boxes {
    flex-direction: row !important;
    height: 100%;
  }
  .box {
    width: 100% !important;
    flex-shrink: 0 !important;
    margin-bottom: 15px;
    padding-bottom: 15px;
  }
  header {
    flex-direction: column !important;
    position: fixed !important;
    top: 0px;
    width: 100%;
    z-index: 1000 !important;
  }
  .content {
    margin-top: 50px !important;
    padding-bottom: 50px;
  }
  header .branding {
    width: 100% !important;
    padding: 0px !important;
    display: none;
    z-index: 10000!important;
  }
  header nav {
    width: 100% !important;
    padding: 0px !important;
    overflow: scroll;
  }
  header nav ul {
    flex-direction: row !important;
  }
  header nav ul li {
   width: 100% !important; 
   max-width: 100% !important;
  }
  .refresh, .logout {
    display: none;
  }
  table {
    width: 100%;
  }
}

tr:nth-child(even) {
  background-color: rgba(0,0,0,0.2);
}
body {
  margin: 0px;
}
body, html {
  margin: 0px;
  padding: 0px;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 10pt;
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
}
* {
  box-sizing:border-box;
}
.positive {
  background-color: red;
  color: #fff;
}
.invalid {
  background-color: orange;
  color: #fff;
}
header {
  width: 100%;
  line-height: 45px;
  background-color: rgb(50, 51, 52);
  color: #fff;
  padding-left: 15px;
  display: flex;
  flex-direction: row;
  line-height: 48px;
  user-select: none;
}
table {
  border-collapse: collapse;
}
thead {
  background-color: rgb(50, 51, 52);
  color: #fff;
  text-align: left;
}
thead th {
  padding-left: 15px;
  padding-top: 5px;
  padding-bottom: 5px;
  font-weight: 100 !important;
}

tbody td, thead th {
  padding-left: 15px;
  padding-top: 5px;
  padding-bottom: 5px;
  border: 0.5px solid rgb(50, 51, 52);
}
header .branding {
  max-width: 250px;
  width: 250px;
  overflow: hidden; 
  text-overflow: ellipsis;
  white-space: nowrap;
}
header nav {
  width: calc(100% - 200px - 150px - 50px);
  padding-left: 15px;
  z-index: 100;
}
header nav ul {
  list-style: none;
  margin: 0px;
  padding: 0px;
  display: flex;
  flex-direction: row;
}
header nav ul li {
  padding-right: 20px;
  padding-left: 20px;
  text-align: center;
  white-space: nowrap;
}

header nav ul li:hover {
  cursor: pointer;
}
.active-menu {
  background-color: #0078ff;
  font-weight: bold;
}
.refresh {
  width: 50px;
  cursor: pointer;
  text-align: center;
}
.refresh:hover {
    -webkit-animation:spin 1s linear infinite;
    -moz-animation:spin 1s linear infinite;
    animation:spin 1s linear infinite;
}

@-moz-keyframes spin { 
    100% { -moz-transform: rotate(360deg); } 
}
@-webkit-keyframes spin { 
    100% { -webkit-transform: rotate(360deg); } 
}
@keyframes spin { 
    100% { 
        -webkit-transform: rotate(360deg); 
        transform:rotate(360deg); 
    } 
}


.logout {
  max-width: 350px;
  padding-right: 30px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
}
.logout ul {
  list-style: none;
  padding: 0px;
  margin: 0px;
}

.logout:hover .submenu {
  display: block;
}
.banner {
  line-height: 48px;
  padding-left: 15px;
}
.content {
  height: 100%;
  width: 100%;
  padding: 15px;
  overflow: none !important;
}
.no-padding {
  padding: 0px !important;
  margin: 0px !important;
  overflow: none !important;
}
.content h1 {
  margin: 0px;
  padding: 0px;
  font-weight: 100;
  padding-bottom: 15px;
  font-size: 12pt;
}

.boxes {
  display: flex;
  flex-wrap: wrap;
}
.box {
  background-color: #0078ff;
  color: #fff;
  width: 200px;
  height: 200px;
  display: flex;
  flex-direction: column;
  margin-right: 10px;
  user-select: none;
  margin-bottom: 10px;
}
.box .number {
  font-size: 50pt;
  margin: auto;
  width: 100%;
  text-align: center;
}
.box .text {
  font-size: 12pt;
  width: 100%;
  text-align: center;
  line-height: 48px;
}

.loginpage {
  height: 100%;
  width: 100%;
  background: url(./assets/bg.jpg);
  background-size: cover;
  display: flex;
  flex-direction: row;
}
.loginform {
  width: 600px;
  height: 300px;
  margin: auto;
}

input {
  padding: 10px;
  border: 1px solid black;
  background-color: transparent;
}

input:focus {
  outline: none;
}

.developer {
  background-color: #f0f1f2;
  border: 5px solid #0078ff;
  margin-bottom: 10px;
  padding: 15px;
}

.magic-button {
  background-color: #0078ff;
  width: 230px;
  color: #fff;
  padding: 5px;
  margin-top: 10px;
  text-align: center;
  cursor: pointer;
}
.magic-button:hover {
  background-color: rgb(50, 51, 52);
}

.disabled {
  filter: blur(4px);
  background-color: rgb(50, 51, 52);
}
select {
  border-radius: 0px;
  border: 1px solid rgb(50, 51, 52);
}
.error {
  padding: 15px;
  background-color: #ff4800;
  color: #fff;
  margin-top: 10px;
}

.success {
  padding: 15px;
  background-color: #98a589;
  color: #fff;
  margin-top: 10px;
}

.chart {
  box-sizing: border-box;
  border: 1px solid rgb(50, 51, 52);
  min-width: 500px;
  height: 400px;
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  margin-right: 15px;
  flex-shrink: 0;
}
.chart .title {
  width: 100%;
  padding: 10px;
  background-color: rgb(50, 51, 52);
  color: #fff;
  text-transform: uppercase;
}
.chart2 {
  height: 100%;
  width: 100%;
}
.charts {
  width: 100%;
  display: flex;
}

.devicenameedit {
  display: flex;
  border: none !important;
}
.devicename {
  width: calc(100% - 25px);
}
.deviceedit {
  width: 25px;
  cursor: pointer;
}
.searchbar {
  display: flex;
}
.searchbar .search {
  width: 300px;
}
.searchbar .icon {
 width: 25px;
}
.adminsearcher {
  border: none;
  color: #fff;
  width: 100%;
}
.adminsearcher::placeholder {
  color: rgba(255,255,255,0.3);
}
.suggestions {
  display: flex;
  position: absolute;
  background-color: red;
  width: 450px;
}
.loading {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
  z-index: 1000;
  display: flex;
  user-select: none;
  opacity: 0.8;
  background-color: #fff;
}
.loading div {
  margin: auto;
  color: black;
  font-size: 40pt;
}
.anydesk {
  background-color: #ef443b;
  color: #fff;
  font-size: 9pt;
  padding-left: 10px;
  padding-right: 10px;
  margin-right: 15px;
  cursor: pointer;
  width: 90px;
  text-align: center;
}
.specialUser {
  background-color: purple;
  line-height: 45px;
  padding-left: 15px;
  color: #fff;
}
.specialUser strong {
  font-weight: 800;
}
.toasty {
  border: 1px solid red;
  position: absolute;
  bottom: 0px;
  right: 0px;
  width: 400px;
  height: 200px;
}

.tnotification {
  padding: 10px;
  border: 1px solid blue;
}
.notification-title {
  line-height: 45px;
}
.notification-content {
  background-color: gold;
}




/* The snackbar - position it at the bottom and in the middle of the screen */
#snackbar {
  visibility: hidden; /* Hidden by default. Visible on click */
  min-width: 250px; /* Set a default minimum width */
  margin-left: -125px; /* Divide value of min-width by 2 */
  background-color: #323232; /* Black background color */
  color: #fff; /* White text color */
  text-align: center; /* Centered text */
  border-radius: 2px; /* Rounded borders */
  padding: 16px; /* Padding */
  position: fixed; /* Sit on top of the screen */
  z-index: 1; /* Add a z-index if needed */
  left: 50%; /* Center the snackbar */
  bottom: 30px; /* 30px from the bottom */
}

/* Show the snackbar when clicking on a button (class added with JavaScript) */
#snackbar.show {
  visibility: visible; /* Show the snackbar */
  /* Add animation: Take 0.5 seconds to fade in and out the snackbar.
  However, delay the fade out process for 2.5 seconds */
  -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
  animation: fadein 0.5s, fadeout 2s 2.5s;
}

/* Animations to fade the snackbar in and out */
@-webkit-keyframes fadein {
  from {bottom: 0; opacity: 0;}
  to {bottom: 30px; opacity: 1;}
}

@keyframes fadein {
  from {bottom: 0; opacity: 0;}
  to {bottom: 30px; opacity: 1;}
}

@-webkit-keyframes fadeout {
  from {bottom: 30px; opacity: 1;}
  to {bottom: 0; opacity: 0;}
}

@keyframes fadeout {
  from {bottom: 30px; opacity: 1;}
  to {bottom: 0; opacity: 0;}
}
</style>


<script>
var protobuf = require("protobufjs");
var root = protobuf.Root.fromJSON(require("/bundle.json"));
var Probe = root.lookupType("TestList");
var Test = root.lookupType("ProbeList");
var Apotheke = root.lookupType("Apotheke");
var Cycler = root.lookupType("CyclerList");
var CancelToken = false;


export default({
  watch: {
    changeuser() {
      var user = this.changeuser;
      window.open("/login/"+user.apoCustomerId+"?email="+user.apoEmail+"&curves=true", "mywindow","menubar=1,resizable=1,width=1300,height=900")
    },
    search() {
      if(!CancelToken) {
        CancelToken = this.axios.CancelToken
      }
      this.axios.get("/api/search?q="+this.search, { headers: { Authorization: 'Barear '+this.$store.getters.accessToken}},{
        cancelToken: CancelToken.source().token
      })
      .then((response) => {
        this.suggestions= [];
        this.suggestions = response.data;
        this.$router.push({
          name: 'AdminSearch',
          params: {
            results: response.data,
          }
        })
      })
    }
  },

  data() {
    return {
      showLoading: false,
      specialUser: false,
      horizontal: false,
      translation: {
        "en": {
          "LANG_NAME": "English",
          "LANG_CODE": "en",
          "STR_EMAIL": "E-Mail",
          "STR_CUSTID": "CustomerID",
          "STR_TITLE_DEVICES": "Your PCR Devices",
          "STR_TITLE_WELCOME": "Welcome at the PCR Management Portal.",
          "STR_TITLE_DOCUMENTS": "Documents",
          "STR_TITLE_TESTS": "Your taken Tests",
          "STR_TITLE_STATS": "Statistics",
          "STR_DASHBOARD": "Dashboard",
          "STR_PROBES_DAY": "Probes per Day",
          "STR_PROBES_DIST": "Probes per Category",
          "STR_DOCUMENTS": "Documents",
          "STR_PCR_DEVICES": "PCR Devices",
          "STR_SCREENING_PORTAL": "Screening Portal",
          "STR_STATS": "Statistics",
          "STR_TESTS": "Tests",
          "STR_SERIAL": "Serialnumber",
          "STR_STATE": "State",
          "STR_ONLINE": "Online",
          "STR_OFFLINE": "Offline",
          "STR_ACTIONS": "Actions",
          "STR_YES": "Yes",
          "STR_NO": "No",
          "STR_BUSY": "In Progress",
          "STR_AVAIL": "Available",
          "STR_SHOW_TESTS": "Show Tests",
          "STR_DEV_CUSTNAME": "Device Name",
          "STR_ADD_DEVICE": "Add new PCR Devices",
          "STR_DATE_TIME": "Date/Time",
          "STR_PROBES": "Probes",
          "STR_POSITIVES": "Positive",
          "STR_INVALIDS": "Invalids",
          "STR_TEST_TYPE": "Test Type",
          "STR_DEVICE": "Device",
          "STR_DOWNLOAD_TODAY": "Download todays Tests",
          "STR_ACT_SHOW": "Show",
          "STR_STATS_DEVICES": "Sum PCR Devices",
          "STR_STATS_BUSYDEVICES": "Sum Working PCR Devices",
          "STR_STATS_SUMTESTS": "Sum Tests",
          "STR_STATS_SUMPROBES": "Sum Probes",
          "STR_STATS_SUMPOSITIVES": "Positive probes",
          "STR_STATS_SUMINVALIDS": "Invalid Probes",
          "STR_STATS_QUOTE": "% Positives",

          "STR_BARCODE": "Barcode",
          "STR_POSITION": "Position",
          "STR_CTValue": "CT Value",
          "STR_Valid": "Valide",
          "STR_RESULT": "Result",
          "STR_RES_VALID": "valid",
          "STR_RES_INVALID": "invalid",
          "STR_RES_POSITIVE": "positive",
          "STR_RES_NEGATIVE": "negative",
          "STR_TESTING_DEVICE": "Reporting Device",
          "STR_FROM": "from",
          "STR_LOGOUT": "Logout",
          "STR_LOGIN": "Login",
          "STR_IFU": "here you will be able to see all PCR device related documents:",
          "STR_IFU_FILE1": "IFU - User Manual",
        },
        "de": {
          "LANG_NAME": "Deutsch",
          "LANG_CODE": "de",

          "STR_EMAIL": "E-Mail",
          "STR_CUSTID": "Kundennummer",

          "STR_TITLE_DEVICES": "Ihre PCR Geräte",
          "STR_TITLE_DOCUMENTS": "Dokumente & Unterlagen",
          "STR_TITLE_WELCOME": "Willkommen bei Ihrer PCR Geräte Verwaltung.",
          "STR_TITLE_TESTS": "Ihre Durchgeführten Testläufe",
          "STR_TITLE_STATS": "Statistik",
          "STR_DASHBOARD": "Dashboard",
          "STR_PROBES_DAY": "Proben pro Tag",
          "STR_PROBES_DIST": "Proben Verteilung",
          "STR_DOCUMENTS": "Dokumente",
          "STR_PCR_DEVICES": "PCR Geräte",
          "STR_SCREENING_PORTAL": "Screening Portal",
          "STR_STATS": "Statistik",
          "STR_TESTS": "Tests",
          "STR_SERIAL": "Seriennummer",
          "STR_STATE": "Status",
          "STR_ONLINE": "Online",
          "STR_OFFLINE": "nicht erreichbar",
          "STR_ACTIONS": "Aktionen",
          "STR_YES": "Ja",
          "STR_NO": "Nein",
          "STR_BUSY": "Auswertung läuft",
          "STR_AVAIL": "Betriebsbereit",
          "STR_SHOW_TESTS": "Tests anzeigen",
          "STR_DEV_CUSTNAME": "Kundeneigene Bezeichnung",
          "STR_ADD_DEVICE": "Weiteres PCR Gerät hinzufügen",
          "STR_DATE_TIME": "Datum/Zeit",
          "STR_PROBES": "Proben",
          "STR_POSITIVES": "Positive",
          "STR_INVALIDS": "Ungültige",
          "STR_TEST_TYPE": "Test Type",
          "STR_DEVICE": "Gerät",
          "STR_DOWNLOAD_TODAY": "Heutige Tests herunterladen",
          "STR_ACT_SHOW": "Anzeigen",
          "STR_STATS_DEVICES": "Anzahl PCR Geräte",
          "STR_STATS_BUSYDEVICES": "Auswertende PCR Geräte",
          "STR_STATS_SUMTESTS": "Anzahl Tests",
          "STR_STATS_SUMPROBES": "Anzahl Proben",
          "STR_STATS_SUMPOSITIVES": "Positive Proben",
          "STR_STATS_SUMINVALIDS": "Ungültige Proben",
          "STR_STATS_QUOTE": "% Positiv",

          "STR_BARCODE": "Barcode",
          "STR_POSITION": "Position",
          "STR_CTValue": "CT Wert",
          "STR_Valid": "Valide",
          "STR_RESULT": "Befundung",
          "STR_RES_VALID": "gültig",
          "STR_RES_INVALID": "ungültig",
          "STR_RES_POSITIVE": "positiv",
          "STR_RES_NEGATIVE": "negativ",
          "STR_TESTING_DEVICE": "Befundendes Gerät",
          "STR_FROM": "vom",
          "STR_LOGOUT": "Abmelden",
          "STR_LOGIN": "Anmelden",
          "STR_IFU": "Nachstehend finden Sie sämtliche Informationen, welche für die Verwendung Ihres POC Gerätes unerlässlich sind:",
          "STR_IFU_FILE1": "IFU - Bedienungsanleitung POC Gerät",
          
        }
      },
      currLang: 'de',
      search: null,
      reloaded: false,
      suggestions: [],
      changeuser: null,
      curves: false,
      notification: false,
    }      
  },
  computed: {
    currentLang() {
      return this.translation[this.currLang];
    }
  },
  mounted() {

      // SpecialUser
      if(location.href.indexOf("su") > -1) {
        this.specialUser = true;
      }
      // curves
      let { curves = false } = this.$route.query;
      if(curves) {
        this.curves = true;
      }    

    setInterval(() => {
      this.$store.dispatch('RefreshStates');
    }, 60000*5)
  },
  methods: {
    ShowNotification(txt) {
      this.notification = txt;
      setTimeout(() => {
        this.notification = false;
      }, 2500)
    },
    KillSpecialUser() {
      this.specialUser = false;
      document.cookie = 'su=; Max-Age=-1'
    },
    LoadingScreen(state) {
      this.showLoading = state;
    },
    SetLang(lang) {
      this.currLang = lang;
    },
    RenewTokens() {
      this.$store.dispatch("RefreshToken")
      .catch(() => {
        this.Logout();
      })
    },
    Reload() {
      if(this.reloaded == false) {
        this.$store.dispatch('RefreshStates');
        this.reloaded = true;
        setTimeout(() => {
          this.reloaded = false;
        }, 2500)
      }
    },
    Logout() {
      this.$store.dispatch('Logout', true);
      this.$router.push({
        name: 'login',
      })
    },
    ChangeRoute(next) {
      this.$router.push({
        name: next,
      })
    },
    getThisTest(id) {
      this.$router.push({
        name: 'showtest',
        params: {
          id: id,
        }
      })
      this.axios.get("https://poc.procomcure.com/api/v2/test?id="+id, { responseType: 'arraybuffer', headers: { Authorization: 'Berear '+this.token} })
      .then((r) => {
        var message = Test.decode(Buffer.from(r.data));
        this.probes = message.Probe;
        this.test = message.Probe;
      })
    }
  },

})
</script>
